import Text from "@pathwright/ui/src/components/ui/Text"
import styled from "styled-components"
import BlockLayoutPreview from "./BlockLayoutPreview"

const BlockOptionWrap = styled.div`
  width: ${180 + 20}px;
  padding: 10px;
  .BlockPreviewWrap {
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
  }

  &:hover {
    .BlockPreviewWrap {
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.18);
    }
  }
`

const BlockOptionLabel = styled(Text.Meta)`
  display: block;
  width: 100%;
  height: 20px;
  text-align: center;
  margin-top: 10px;
`

const BlockOption = (props) => {
  const { blockType, layout, label, data } = props

  const handleSelect = (e) => {
    props.onSelect(blockType, data, layout)
  }

  return (
    <BlockOptionWrap
      className={`BlockOption BlockOption--${blockType.toLowerCase()}-${layout}`}
      onClick={handleSelect}
      tabIndex="0"
    >
      <BlockLayoutPreview {...props} type={blockType} onChange={() => {}} />
      <BlockOptionLabel>{label}</BlockOptionLabel>
    </BlockOptionWrap>
  )
}

export default BlockOption
